/* App code lives in bootstrap.tsx so webpack can initialize the federation shared scope
 (react, react-dom, etc.) before any of its imports execute. */
import("./bootstrap").catch((err) => {
  console.error("Shell failed to bootstrap.", err);

  const container = document.getElementById("root");
  if (container) {
    container.textContent = "The application failed to start. Please reload the page.";
  }
});
